import { Box } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AmendsBoundaryEditor } from "../amends/components/amends-boundary-editor"

export function AuthoringReviewAmendsBlock({ amendsKey, subtitle, cyPrefix = "review-amends" }) {
    const { amendsContext } = useBoundContext()
    if (!amendsContext || !amendsKey) return null

    const amendsState = amendsContext.getAmendsState(amendsKey)
    if (!amendsState?.isOpen) return null

    return (
        <Box width={1} data-cy={getReviewAmendsCy(amendsKey, cyPrefix)}>
            <AmendsBoundaryEditor amendsKey={amendsKey} subtitle={subtitle} />
        </Box>
    )
}

function getReviewAmendsCy(amendsKey, cyPrefix) {
    const safeAmendsKey = `${amendsKey ?? ""}`.replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "")
    return `${cyPrefix}-${safeAmendsKey}`
}
